import React,{ useContext, useState, useEffect} from 'react';

import NewProductItm from "../newProductItm/NewProductItm"



//css
import "./ModuloItem.css"

// Constante con estructura del producto.
export const estructura_producto =
{
    tipPro: "",
    artCod: "",
    codRed: "",
    descrp: "",
    quantity: "1",
    textAdic: "",
    activoID: "",
    codActivoID:"",
    productID: "",
    comUserID:"",
    userName:"",
    usr_id: (Math.random() * 100).toString()
}

function ModuloItem({activo,modo,itemsList, products, setItemsList, activoComponente, 
    items, setItems}) {
    
    const componente = activoComponente?.products  
    useEffect( () => {
        if(itemsList?.length === 0) setItems([estructura_producto])
        if(modo === "Vista") {setItems(componente); setItemsList(componente)}
        if( modo !== "Vista") setItems(itemsList?.concat([estructura_producto]))
       // if( modo === "Home") setItems(itemsList?.concat([...estructura_producto, {codRed:"", tDocCodFor:"", tDocNroFor:""}]))
    },[modo, activo]);

    /* 
        Manejador encargado de agregar un item a los items del requerimiento.
        Donde data es el producto a añadir a los items.
        Se agrega el producto seleccionado y al final se agrega un item vacio (Constante estructura del producto).
    */
        const handleagregaItem = (data, i) => {
            //Se le asigna un id random al nuevo producto añadido. Esto es para facilitar la eliminación del item en caso de ser necesario.
            const tempData = {...data, usr_id: (Math.random() * 100).toString()};
            
            //Se le asigna un id random al item vacio. Esto es para facilitar la eliminación del item en caso de ser necesario.
            const nuevaEstructura = {...estructura_producto, usr_id: (Math.random() * 100).toString()};

            //Logica para determinar donde inserta el item vacio.
            const temp_List =  items.length === 1 ? [nuevaEstructura] : items?.map( (d,index) => ( index !== i ? d : nuevaEstructura ));

            const newLista = temp_List.length === 1 ? [tempData, ...temp_List] : [...temp_List.filter((d) => (d.artCod !== '' )), tempData, nuevaEstructura];

            setItemsList(newLista );
            setItems(newLista );

        }

    /* 
        Manejador ante cambio en los items.
            Donde data es el item modificado.
            Donde i es la posición del item modificado
        Setea los items despues de reemplazar  el item por el recibido por parametro.
    */
       
        const handleChangeItm = (data, i, original) => {

            const newLista = items.map((it, index) => {

                return ( it?.artCod === original?.artCod && index === i) ? data : it;
            })
            
            setItemsList( newLista); 
            setItems(newLista);
        }

    /*
        Manejador encargado de eliminar un item de los items del requerimiento.
            Donde item es el item completo a eliminar.
            Donde i es la posición del item a eliminar.
        Setea los items despues de filtrar la posición indicada por parametro.
    */
        const handleDeleteConcept = (item, i) => {

            if (i >= 0 && item.tipPro !== ""  ) {
                setItems(items.filter((data, index) => index !== i ));
                setItemsList(items.filter((data, index) => index !== i));
                
            } else {
                console.warn("Índice fuera de los límites de las listas.");
            }
        
        }

    return (

        <div className='container-AddReq-item-details-items'>
                <div className='container-r-item-title-details'>
                    Items: {(items?.length === 0 || componente?.length === 0) ? 0 : (modo !== "Vista" ? items?.length - 1 : componente.length )}
                </div>
               
                    {
                        items?.length > 0 &&
                        items?.map((c, index) => {
                            
                            return <NewProductItm data={c} index={index} key={c?.usr_id} productsList={products} 
                                    agregaItem={(data, i) => handleagregaItem(data,i)} 
                                    modificaItm={(data, indice, original) => handleChangeItm(data, indice, original)} 
                                    borraItem={() => handleDeleteConcept(c, index)} modo={modo} 
                                    componente={componente?.filter(item=>(c.artCod === item.artCod))}
                                    
                                    />          
                        })
                    }
        </div>   
    )
}

export default ModuloItem